import React from 'react';
import { useLanguage } from '../../hooks/useLanguage';
import { useLanguageModal } from '../../contexts/LanguageModalContext';

const LanguageSwitcher: React.FC = () => {
  const [language] = useLanguage();
  const { openLanguageModal } = useLanguageModal();

  const getLanguageFlag = (lang: string | null) => {
    switch (lang) {
      case 'es': return '🇪🇸';
      case 'ru': return '🇷🇺';
      case 'ro': return '🇷🇴';
      case 'pt': return '🇵🇹';
      default: return '🇺🇸';
    }
  };

  return (
    <button
      onClick={openLanguageModal}
      className="border-none cursor-pointer p-2 rounded-md hover:bg-white/30 transition-all duration-300 flex items-center justify-center"
      title="Change Language"
    >
      <span className="text-lg">{getLanguageFlag(language)}</span>
    </button>
  );
};

export default LanguageSwitcher;